<mat-sidenav-container class="matp-sidenav-container">
  <!-- サイドメニュー -->
  <mat-sidenav
    #sidenav
    class="matp-sidenav"
    [mode]="mode"
    [(opened)]="opened"
    [disableClose]="mode === 'side'"
    (closedStart)="close()"
  >
    <mat-nav-list class="tw-text-center matp-nav-list">
      @for (item of navItems; track item) {
        <!-- メニュー -->
        @if (item.type === "menu") {
          <mat-list-item
            matTooltip="{{ item.name }}"
            matTooltipPosition="right"
            routerLinkActive
            [routerLinkActiveOptions]="{
              matrixParams: 'ignored',
              queryParams: 'ignored',
              paths: 'subset',
              fragment: 'ignored',
            }"
            #routerLink="routerLinkActive"
            class="!tw-h-16 !tw-px-1"
            (click)="openSideNav()"
          >
            <!-- 選択バー -->
            <div
              *ngIf="routerLink.isActive"
              class="matp-bg-primary tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1"
            ></div>

            <mat-icon
              class="tw-text-4xl !tw-h-9 !tw-w-9"
              [ngClass]="{
                'matp-icon-default': !routerLink.isActive,
                'matp-text-primary': routerLink.isActive,
              }"
            >
              {{ item.icon }}
            </mat-icon>
            <div
              class="tw-text-[0.5rem] tw-leading-none"
              [ngClass]="{
                'matp-icon-default': !routerLink.isActive,
                'matp-text-primary': routerLink.isActive,
              }"
            >
              {{ item.name }}
            </div>
            <div
              class="tw-absolute tw-top-0 tw-right-0"
              #menuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="menu"
            ></div>
            <!-- メニュー内容 -->
            <mat-menu xPosition="after" #menu="matMenu">
              @for (child of item.children; track child) {
                <button
                  mat-menu-item
                  [routerLink]="child.path"
                  routerLinkActive
                  [routerLinkActiveOptions]="{
                    matrixParams: 'ignored',
                    queryParams: 'ignored',
                    paths: 'exact',
                    fragment: 'ignored',
                  }"
                  #childRouterLink="routerLinkActive"
                  (click)="onClickedLink()"
                >
                  <!-- 選択バー -->
                  <div
                    *ngIf="childRouterLink.isActive"
                    class="matp-bg-primary tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1"
                  ></div>

                  <div
                    class="tw-leading-none"
                    [ngClass]="{
                      'matp-icon-default': !childRouterLink.isActive,
                      'matp-text-primary': childRouterLink.isActive,
                    }"
                  >
                    {{ child.name }}
                  </div>
                </button>
              }
            </mat-menu>
          </mat-list-item>

          <!-- 各リンク -->
        } @else {
          <mat-list-item
            matTooltip="{{ item.name }}"
            matTooltipPosition="right"
            [routerLink]="item.path"
            routerLinkActive
            [routerLinkActiveOptions]="{
              matrixParams: 'ignored',
              queryParams: 'ignored',
              paths: 'subset',
              fragment: 'ignored',
            }"
            #routerLink="routerLinkActive"
            class="!tw-h-16 !tw-px-1"
            (click)="onClickedLink()"
          >
            <!-- 選択バー -->
            <div
              *ngIf="routerLink.isActive"
              class="matp-bg-primary tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1"
            ></div>

            <mat-icon
              class="tw-text-4xl !tw-h-9 !tw-w-9"
              [ngClass]="{
                'matp-icon-default': !routerLink.isActive,
                'matp-text-primary': routerLink.isActive,
              }"
            >
              {{ item.icon }}
            </mat-icon>
            <div
              class="tw-text-[0.5rem] tw-leading-none"
              [ngClass]="{
                'matp-icon-default': !routerLink.isActive,
                'matp-text-primary': routerLink.isActive,
              }"
            >
              {{ item.name }}
            </div>
          </mat-list-item>
        }
      }
    </mat-nav-list>
  </mat-sidenav>

  <!-- メインコンテンツ -->
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
